import React from 'react';
import PropTypes from 'prop-types';
import { coordinatePropType } from '../../utils/proptypes';

var Area = function Area(_ref) {
  var start = _ref.start,
      end = _ref.end,
      color = _ref.color,
      opacity = _ref.opacity;

  if (!start || !end) {
    return null;
  }
  var width = Math.abs(start.xpos - end.xpos);
  var left = Math.min(start.xpos, end.xpos);
  var height = Math.abs(start.ypos - end.ypos);
  var top = Math.min(start.ypos, end.ypos);
  return React.createElement('rect', {
    width: width,
    height: height,
    x: left,
    y: top,
    pointerEvents: 'none',
    style: { stroke: color, fill: color, fillOpacity: opacity }
  });
};

Area.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  start: coordinatePropType.isRequired,
  end: coordinatePropType,
  opacity: PropTypes.number
} : {};

Area.defaultProps = {
  color: '#000',
  opacity: 0.15,
  end: null
};

export default Area;